import type {ReactAction} from '@netx/core/bootstrap';
import {faICursor} from '@netx/core-icons';
import {canRenameSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionRenameIcon = faICursor;

/**
 * Rename saved cart
 * @param params
 * @returns Action
 */
export const cartSavedActionRename = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-rename',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.RENAME, savedCart),
	enableTest: () => canRenameSavedCart(savedCart),
	icon: cartSavedActionRenameIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.RENAME;
	},
	...params,
});

export default cartSavedActionRename;
